import { create } from 'zustand';
import type { PodcastListPage, Podcast } from '@edwin-group/people-graphql';
interface PodcastListState {
  page: PodcastListPage | null;
  podcasts: Podcast[];
  pagination: {
    page: number;
    pageCount: number;
    total: number;
    pageSize: number;
  };
  loading: boolean;
}

interface PodcastListActions {
  setPage: (page: PodcastListPage) => void;
  setPodcasts: (podcasts: Podcast[]) => void;
  appendPodcasts: (podcasts: Podcast[]) => void;
  setPagination: (pagination: PodcastListState['pagination']) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

const initialState: PodcastListState = {
  page: null,
  podcasts: [],
  pagination: {
    page: 1,
    pageCount: 1,
    total: 0,
    pageSize: 10,
  },
  loading: false,
};

export const usePodcastListStore = create<PodcastListState & PodcastListActions>((set) => ({
  ...initialState,
  setPage: (page) => set({ page }),
  setPodcasts: (podcasts) => set({ podcasts }),
  appendPodcasts: (podcasts) => set((state) => ({ podcasts: [...state.podcasts, ...podcasts] })),
  setPagination: (pagination) => set({ pagination }),
  setLoading: (loading) => set({ loading }),
  reset: () => set(initialState),
}));
